<template>
  <div class="purchase_Wrapper">
    <div class="header_top">
      <div style="font-size:22px;font-weight:bold;margin-bottom:20px">
          {{$t('other.a1325')}}：{{itemsCount}}{{$t('other.a1326')}}
      </div>
       
      <!-- 一级菜单栏 -->
      <div class="query_list">
        <div style="display:flex">
          <div style="width: 307px">
            {{$t('other.a914')}}：
          <el-select
            @change="getStoreItemAndGroup()"
            v-model="warehouseId"
            :placeholder="$t('other.a914')"
          >
            <el-option
              v-for="item in warehouseOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div style="width: 150px;margin:0 10px">
          <el-select
            @change="getStoreItemAndGroup()"
            v-model="componentValue"
            :placeholder="$t('other.a914')"
          >
            <el-option
              v-for="item in options2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div >
          <el-input
            style="width: 320px;margin-right:5px"
            clearable
            :placeholder="$t('other.a1327')"
            v-model="cusCode"
          ></el-input>
          <el-button type="primary" @click="getStoreItemAndGroup()">{{
            $t("userStoreItems").search
          }}</el-button>
        </div>
        </div>
        <div class="create">
            <el-button type="primary"  @click="toPurchase()">{{$t('other.a1328')}}</el-button>
            <span class="cirlle">{{targetList.length}}</span>
        </div>
      </div>
    </div>
    <!-- 产品展示列表 -->
    <div class="goodsArea">
      <el-tabs v-model="activeName"  type="border-card" @tab-click="handleClick">
    <el-tab-pane :label="$t('other.a1329')" name="first">
      <div class="item_list_wrpper" v-for="(item,index) in newUserstoreItem" :key="index">
            <div class="headerDesc">
                <div>{{$t('other.a659')}}：{{item.itemSku ? item.itemSku : $t('other.a354')}}</div>
                <div>
                    <el-button size="mini" :type="item.checked01 ? 'danger' : 'primary'" @click="getAll(item,index)">{{item.checked01 ? $t('other.a1331') : $t('other.a1332')}}</el-button>
                </div>
            </div>
            <div class="item_list">
                <div class="imgBox">
                <img style="width:100%" :src="item.image ? item.image : item.storeItems[0].image" alt="">
                </div>
                <div class="itemDesc">
                    <div>{{item.groupName}}</div>
                </div>

                <div style="flex:1">
                    <div class="variation" v-for="(children,index02) in item.storeItemsCopy" :key="index02">
                            <span class="children">{{$t('other.a736')}}:{{children.skuName}}</span>
                            <span class="children">{{$t('other.a226')}}{{children.cusCode}}</span>
                            <span class="children">{{$t('other.a1171')}}:{{children.storeNum}}</span>
                            <span class="children">
                                <el-button size="mini" :type="children.checked ? 'danger' : 'primary'"  @click="target(item,children,index02)">{{children.checked ? $t('other.a1333') : $t('other.a1334')}}</el-button>
                            </span>
                    </div>
                    <div class="moreData" v-show="item.storeItemsCopy.length !== item.storeItems.length && item.storeItems.length > 4" @click="viewMore(item,index)">{{$t('other.a1335')}} sku ({{$t('other.a964')}}{{item.storeItems.length}}{{$t('other.a1337')}})</div>
                    <div class="hideData" v-show="item.storeItemsCopy.length == item.storeItems.length && item.storeItems.length > 4" @click="hideMore(item,index)">{{$t('other.a1336')}}</div>
                </div>
            </div>
        </div>
    </el-tab-pane>
    <el-tab-pane :label="$t('other.a1330')" name="second">
      <div style="margin:20px">
        {{$t('other.a1338')}}：<el-select v-model="param.orderStatus" :placeholder="$t('other.a50')" @change="statussubit">
          <el-option
            v-for="item in statusData"
            :key="item.values"
            :label="item.label"
            :value="item.values">
          </el-option>
        </el-select>
      </div>
      <div class="item_list_wrpper" v-for="(item,index) in paramData" :key="index">
            <div class="headerDesc">
                <div>{{$t('other.a1145')}}：{{item.purchaseOrderId ? item.purchaseOrderId : $t('other.a354')}}</div>
                <div>
                    <el-button size="mini" :type="item.checked01 ? 'danger' : 'primary'" @click="getAllpro(item,index)">{{item.checked01 ? $t('other.a1331') : $t('other.a1332')}}</el-button>
                </div>
            </div>
            <!-- <div v-for="(goods,index) in item.purchaseOrderProducts" :key="index">
                {{goods.amount}}
            </div> -->
            <div class="item_list" v-for="(goods,index02) in item.purchaseOrderProducts" :key="index02">
              <div v-if="goods.userStoreItem" class="item_list">
                    <div class="imgBox">
                <img style="width:100%" :src="goods.userStoreItem.image" alt="">
                </div>
                <div class="itemDesc">
                    <div>{{goods.storeItemGroup.groupName}}</div>
                </div>

                <div style="flex:1">
                    <div class="variation">
                            <span class="children">{{$t('other.a736')}}:{{goods.userStoreItem.skuName}}</span>
                            <span class="children">{{$t('other.a226')}}{{goods.userStoreItem.cuscode}}</span>
                            <span class="children">{{$t('other.a1171')}}:{{goods.userStoreItem.storeNum}}</span>
                            <span class="children">{{$t('other.a1125')}}：{{goods.amount}}</span>
                            <!-- <span class="children">
                                <el-button size="mini" :type="goods.checked ? 'danger' : 'primary'"   @click="targetpro(goods,index02)">{{goods.checked ? $t('other.a1333') : $t('other.a1334')}}</el-button>
                            </span> -->
                    </div>
                   
                </div>
              </div>
              <div v-if="goods.userStoreItem==null">
                  {{$t('other.a1196')}}
              </div>
              
            </div>
        </div>
    </el-tab-pane>
    
  </el-tabs>
        

        <!-- 分页器 -->
        <div class="Pager">
          <el-pagination
            @size-change="handleSizeChangeTwo"
            @current-change="handleCurrentChangeTwo"
            :current-page="currentPage"
            :page-sizes="[15, 20, 30, 100]"
            :page-size="15"
            layout="total, sizes, prev, pager, next, jumper"
            :total="itemsCount"
          >
          </el-pagination>
        </div>
    </div>
  </div>
</template>

<script>

import userStoreItems from "../../api/moudles/userStoreItems";
import api from '../../api/api'
import QrcodeDialog from '../../components/dialog/qrcodeDialog'
import utils from '../../utils/utils'
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      statusData:[
        {
          values: "PURCHASING",
          label: this.$t('other.a1211'),
        },
        
        {
          values: "BEFORE_TRANSFERING",
          label: this.$t('other.a1212'),
        },
        {
          values: "TRANSFERING",
          label: this.$t('other.a1213'),
        },
        {
          values: "BEFORE_ARRIVED",
          label: this.$t('other.a1214'),
        },
        {
          values: "IN_WAREHOUSE",
          label: this.$t('other.a1215'),
        },
        {
          values: "COMPLETED",
          label: this.$t('other.a119'),
        }
      ],
      parmCount:null,
      purchaseIdArrList:[],
      parmTotal:null,
      param :{
        storeId:"",
        orderStatus: "COMPLETED",
        pageNum: 1,
        pageSize: 15,
        userId: JSON.parse(localStorage.getItem("userInfo")).userId
      },
      paramData:[],
      activeName: 'first',
      openDialog: false,
      warehouseId: null,
      warehouseOption: null,
      TitleDesc: "",
      handleParam: null,
      cusCode: "",
      newUserstoreItem: [],
      offset: 15,
      instockdia:false,
      getDataList: null,
      page: 0,
      checkedAll: false,
      isExtened: false,
      maincusCode:0,
      isEdit: -1,
      dialogTableVisibleTwo: false,
      additionParents: [],
      isShow: false,
      isEditGoods: false,
      multipleSelection: [],
      additionItem: null,
      listErrorOptions: [],
      targetList:[],
      itemsCount:0,
      tableList: [],
      tableCount: 0,
      currentPage4: 1,
      currentPage:1,
      page: 0,
      componentValue:1,
      value: null,
       options2: [
        {
          label: this.$t('other.a251'),
          value: 1,
        },
        {
          label: this.$t('other.a1339'),
          value: 2,
        },
        {
          label: this.$t('other.a497'),
          value: 3,
        },
      ],
      options: [
        {
          label: this.$t('other.a1340'),
          value: null,
        },
        {
          label: this.$t('other.a1341'),
          value: true,
        },
        {
          label: this.$t('other.a1342'),
          value: false,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      userId: (state) => state.shopaccess.userInfo.userId,
      userName: (state) => state.shopaccess.userInfo.userName,
      isChooseList: (state) => state.userStoreItems.isChooseList
    }),

 
    
  },
  watch: {
      cusCode(){
          if(!this.cusCode){
              this.getDataList.cusCode=null
              this.getData()
          }
      },
      warehouseId(){
          localStorage.removeItem('godownentry')
          this.targetList=[]
      }
  
    
    
  },
  beforeDestroy(){
      localStorage.removeItem('godownentry')
  },

  created() {
    
    let arr1=[]
    let arr2=[]
    JSON.parse(localStorage.getItem("userInfo")).stores.forEach((p) => {
      if(p.isUsed){

        if(p.storeType == 1){
          arr1.push( {
          label: p.storeName,
          value: p.storeId,
        })
        }else{
          arr2.push( {
          label: p.storeName,
          value: p.storeId,
        })
        }
      }
     
    });
    this.warehouseOption = [...arr1,...arr2]
    let storeId=utils.getDefalultStoreId()
    this.warehouseId =storeId ? storeId : this.warehouseOption[0].value
    this.getStoreItemAndGroup();
    this.getproducts();
  },
  methods: {
    

    ...mapActions("userStoreItems", [
      "updateGroup",
      "sellerUpdateStoreItemDetail",
      'getInstockoperaterecore',
        'deleStoreItems'
    ]),


    ...mapMutations('userStoreItems', [
        'SET_ITEMS_COUNT',
        

    ]),
    statussubit(){
      console.log(this.param.orderStatus);
      this.getproducts();
    },
    handleClick(){
      
      this.targetList = [];
      if(this.activeName == 'second'){
        this.itemsCount = this.paramTotal;
      }else if(this.activeName == 'first'){
        this.itemsCount = this.parmCount;
      }
    },//
    getproducts(){
      this.param.storeId = this.warehouseId
        api
        .getorderlistde(this.param)
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            this.paramTotal = res.result.pageInfo.total;
            res.result.purchaseOrders.forEach((p) => {
           
            p.checked02 = false;
            
            p.purchaseOrderProducts.forEach((k) => {
                k.checked = false;
                // k.userStoreItem.cuscode =k.userStoreItem.cuscode;
                // k.userStoreItem.orderId = k.purchaseOrderId
                // k.userStoreItem.amount = k.amount;
            });
             });
            this.paramData = res.result.purchaseOrders;
            // res.result.purchaseOrders.forEach((p)=>{
            //     if(p.purchaseOrderProducts){
            //       for(let i = 0 ;i<p.purchaseOrderProducts.length;i++){
            //         this.paramData.push(p.purchaseOrderProducts[i])
            //       }
            //     }
            // });
              console.log(this.paramData)
          }else{
            this.$message.warning(res.msg);
          }
         
        });
    },
    getAll(item,index){
        console.log(item,index)
        item.checked01=!item.checked01
  
        if(item.checked01){
            item.storeItems.forEach(p => {
                if(!p.checked){
                    this.targetList.push(p)
                }
                p.checked=true
            })
        }else{
            item.storeItems.forEach(p => {
                p.checked=false
                let index=this.targetList.findIndex(item => item.cusCode == p.cusCode)
                this.targetList.splice(index,1)
            })
        }
        localStorage.setItem('godownentry',JSON.stringify(this.targetList))
        console.log('targetList',this.targetList)
    },
    getAllpro(item,index){
      // console.log(item.purchaseOrderProducts);
      console.log('item',item)
      
      
      item.checked01=!item.checked01
  
        if(item.checked01){
            item.purchaseOrderProducts.forEach(p => {
                if(!p.checked){
                    this.targetList.push(p.userStoreItem)
                }
                p.checked=true
            })
            this.purchaseIdArrList.push(item.purchaseOrderId)
        }else{
            item.purchaseOrderProducts.forEach(p => {
                p.checked=false
                let index=this.targetList.findIndex(item => item.cusCode == p.cusCode)
                this.targetList.splice(index,1)
            })
            this.purchaseIdArrList.splice(index,1,null)
        }
        console.log('purchaseIdArrList',this.purchaseIdArrList)
        localStorage.setItem('godownentry',JSON.stringify(this.targetList))
        console.log('targetList',this.targetList)
    },
    targetpro(item){
      console.log(item);
      item.checked=!item.checked
        if(item.checked){
            this.targetList.push(item.userStoreItem)
        }else{
            let index=this.targetList.findIndex(item => item.cusCode == item.cusCode)
            this.targetList.splice(index,1)
        }
        localStorage.setItem('godownentry',JSON.stringify(this.targetList))

        console.log('targetList',this.targetList)
      // this.targetList.push(goods.userStoreItem);
      // console.log(this.targetList);
    },
    hideMore(item,index){
        item.storeItemsCopy=item.storeItems.slice(0,4)
    },

    viewMore(item,index){
        console.log(item,index)
        item.storeItemsCopy=item.storeItems
    },

    target(outitem,item,index){
        item.checked=!item.checked
        if(item.checked){
            this.targetList.push(item)
        }else{
            let index=this.targetList.findIndex(item => item.cusCode == item.cusCode)
            this.targetList.splice(index,1)
        }
        localStorage.setItem('godownentry',JSON.stringify(this.targetList))

        console.log('targetList',this.targetList)
    },

    toPurchase(){
        this.targetList.forEach(p => {
          if(p.amount){
            p.num = p.amount
          }else{
             p.num=1
          }
           
            p.anotherName='',
            p.variation = p.variation ?  p.variation : {
                variationId: 0,
                name: '',
                stock: 0
            }    
        })

        console.log('sdfd',this.targetList)
        let list=this.purchaseIdArrList.filter(p => {
          if(p){
            return p
          }
        })

        localStorage.setItem('purchaseIdArrList',JSON.stringify(list))

        
       
        if(this.$route.query.purchaseId){
            utils.cleanStorageData()
            localStorage.setItem('purchaseItems',JSON.stringify(this.targetList))
            this.$router.push({path:'/purchaseDetail',query:{purchaseId:this.$route.query.purchaseId,typeNum:this.activeName}})
        }else{
            utils.cleanStorageData()
            localStorage.setItem('purchaseItems',JSON.stringify(this.targetList))
            this.$router.push({path:'/purchaseDetail',query:{storeId:this.warehouseId,typeNum:this.activeName}})
        }

        
        console.log('list',list)
        
    },

    getStoreItemAndGroup() {
       
    this.getDataList = {
      offset: this.offset,
      page: this.page,
      userId: this.userId,
      independent:this.componentValue == 2 ? true : false,
      storeId: this.warehouseId,
      sellerId: this.userId,
      addition: this.componentValue == 3 ? true : false,
      component:  this.componentValue == 1 ? true : this.componentValue == 3 ? true : false,
      cusCode: this.cusCode,
      isEdit: false,
    };
      //获取页面赠品的数据
      this.getData();
      this.getproducts();
    },

    getData(){
        let list=JSON.parse(localStorage.getItem('godownentry'))
        console.log('ikmbv',list)
      userStoreItems.getStoreItem(this.getDataList).then((res) => {
        if (res.code === 200) {
          this.parmCount = res.data.count
          this.itemsCount=res.data.count
           this.newUserstoreItem=[]
          if(!res.data.groups.length){
            this.newUserstoreItem=[]
            return
          }
          res.data.groups.forEach((p) => {
           
            p.checked02 = false;
            
            p.storeItems.forEach((k) => {
                
                if(list){
                    k.checked = list.find(item => item.cusCode === k.cusCode)
                }else{
                    k.checked=false
                }

                if(!k.checked){
                     p.checked01 = false;
                }else{
                    p.checked01 = true;
                }
            });


            p.storeItemsCopy=p.storeItems.slice(0,4)
            this.newUserstoreItem.push(p);
          });

          console.log('list',this.newUserstoreItem)
        }
      });
    },

    //控制每页显示订单条数
    handleSizeChangeTwo(val) {
      console.log(val)
      this.param.pageSize = val;
      this.getDataList.offset = parseInt(`${val}`);
      // this.handleCurrentChangeTwo();
      this.getData();
      this.getproducts();
    },
    //显示当前第几页
    handleCurrentChangeTwo(val) {
      console.log(val)
      this.param.pageNum = val;
      this.getDataList.page = `${val}` == "undefined" ? 0 : (parseInt(`${val}`) - 1) * this.getDataList.offset;
      this.getData();
      this.getproducts();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.purchase_Wrapper {
  margin-top: 70px;
  background-color: #eee;
 
  // @include main-right-content();

  .Pager{
    position: fixed;
		bottom: 0;
		left: 205px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	
  }

  /deep/ .el-checkbox__inner {
    width: 20px;
    height: 20px;
  }

  /deep/ .el-checkbox__inner::after {
    height: 10px;
    left: 7px;
    width: 4px;
    font-weight: bold;
  }

  .header_top {
    position: fixed;
    width: 100%;
    top:50px;
    box-sizing: border-box;
    
    padding: 10px 225px 10px 0;
    background-color: #fff;
    z-index: 9;
    border-bottom: 1px solid #eee;

    .query-list-tcp {
      padding: 10px 0 20px 0;
    }
    .query_list {
    
      padding: 20px 0 5px 0;
      @include flex-between();
    }

    .create {
		position: relative;
		margin-left: 30px;
	}

    .cirlle {
		position: absolute;
		top: -15px;
		left: -13px;
		display: block;
		width: 30px;
		height: 30px;
		background-color: red;
		border-radius: 50%;
		text-align: center; 
		line-height: 30px;
		color: #fff;
	}
  }

  .goodsArea {
    height: 100vh;
    margin-top: 135px;
    margin-bottom: 40px;
    box-sizing: border-box;
    padding: 10px;

    .children{
        display: inline-block;
        margin-right:8px ;
        

    }

    .moreData{
        text-align: center;
        color:red;
        font-size: 12px;
        cursor: pointer;
        padding: 3px 0;
    }

    .hideData{
        text-align: center;
        color:#409EFF;;
        font-size: 12px;
        cursor: pointer;
       
        padding: 3px 0;
    }

  

    .variation{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        border-bottom: 1px solid #eee;
        padding-right: 20px;
        padding-bottom: 5px;;
        
    }

    .children:nth-child(1){
        width: 250px;
        word-break: normal;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }

    .children:nth-child(2){
        width: 150px;
        word-break: normal;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }

    .item_list{
        display: flex;
        
        border-bottom: 1px solid #eee;
        background-color: #fff;
        padding: 5px 0;

    }

    .item_list_wrpper{
        margin-bottom: 10px;
        border-bottom: 1px solid #eee;
        background-color: #fff;
        padding: 5px 0;
        border-radius: 3px;
        box-sizing: border-box;
        padding-left: 10px;
    }

    .itemDesc{
        width: 30%;
        overflow: hidden;
        margin: 0 20px;
    }

    .headerDesc{
        border-bottom: 1px solid #eee;
        display: flex;
        justify-content: space-between;
        padding:5px 30px 5px 0;
    }

    .imgBox{
        width: 60px;
        height: 60px;
        overflow: hidden;
    }
  }

  
}
</style>